import { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'

import { Layout, Text } from '@loadsmart/miranda-react'

import { AsyncContent } from 'core/ui/async-content/AsyncContent'
import { useAbortController } from 'core/ui/hooks/useAbortController'

import { type Load } from '../../domain/Load'
import { usePendingResponses } from '../../hooks/usePendingResponses'
import { TenderCard } from '../TenderCard/TenderCard'

const StyledSection = styled(Layout.Stack)`
  padding: 24px 24px 0 24px;
`

export function PendingResponses() {
  const abortController = useAbortController()
  const [confirmedTenders, setConfirmedTenders] = useState<Array<Load>>([])
  const { pendingResponses, pendingResponsesStatus, fetchPendingResponses } =
    usePendingResponses(abortController)

  const filteredPendingResponses = useMemo(() => {
    return pendingResponses.filter(pendingResponse => {
      if (pendingResponse.type === 'tender' && confirmedTenders.includes(pendingResponse.value)) {
        return false
      }
      return true
    })
  }, [confirmedTenders, pendingResponses])

  function handleTenderAction(load: Load) {
    setConfirmedTenders(prevConfirmedTenders => {
      return [...prevConfirmedTenders, load]
    })
  }

  useEffect(() => {
    fetchPendingResponses()
  }, [fetchPendingResponses])

  return (
    <AsyncContent
      status={pendingResponsesStatus}
      count={filteredPendingResponses.length}
      loadingState={null}
    >
      <StyledSection gap="spacing-4">
        <Layout.Stack gap="spacing-2">
          <Text variant="heading-md-bold">Pending responses</Text>
          <Text variant="heading-sm">Accept the offers below before it expires!</Text>
        </Layout.Stack>
        {filteredPendingResponses.map(pendingResponse => {
          if (pendingResponse.type === 'tender') {
            const load = pendingResponse.value
            return (
              <TenderCard
                key={load.id}
                load={load}
                onAccept={handleTenderAction}
                onReject={handleTenderAction}
              />
            )
          }

          return null
        })}
      </StyledSection>
    </AsyncContent>
  )
}
